<app-loading-spinner [active]="exporting"
    [customMessage]="'Gerando Relatório. Não feche esta janela...'"
    [persistentMessage]="true"
    [showContinueButton]="true"></app-loading-spinner>
<div class="dashboard">
    <div class="row w-100">
        <div class="col-12 ml-auto mr-auto p-0">
            <div class="dash-card">
                <ng-container *ngIf="!loading">
                    <!-- <app-back-button></app-back-button> -->
                </ng-container>

                <!-- <ng-container *ngIf="!loading">
                    <app-table size="xl" [headers]>
                    </app-table>
                </ng-container> -->

                <div class="row no-gutters">
                    <!-- Título sempre visível -->
                    <div class="col-12">
                        <div class="dash-card-header"
                            style="flex-direction: column; padding-bottom: 0;">
                            <div class="row no-gutters">
                                <div
                                    class="col-12 d-flex justify-content-between align-items-center">
                                    <h2>Todos os cadastros</h2>
                                    <div *ngIf="permissionObj.canAdd">
                                        <app-button class="add-button"
                                            (click)="toggleNewUserModal()">
                                            <svg-icon
                                                src="assets/images/icon-add.svg"
                                                class="mr-2 mt-1 mb-1"></svg-icon>
                                            Novo cadastros
                                        </app-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Summary Cards -->
                    <div class="col-12">
                        <div class="dash-card-statistics">
                            <ng-container *ngIf="loadingSummary">
                                <div class="col-12 p-0">
                                    <div class="summary-skeleton-grid">
                                        <ngx-skeleton-loader
                                            *ngFor="let _ of [1,2,3,4,5,6,7,8,9]"
                                            [theme]="{
                                                height: '89px',
                                                width: '100%',
                                                margin:'0'
                                            }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="!loadingSummary">
                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Em aprovação
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.aguardando_aprovacao
                                        }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Homologados
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.homologados
                                        }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Cedentes
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.cedente
                                        }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Cotistas
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.cotista
                                        }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Prestadores de Serviços
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.prestador
                                        }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Representantes
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.representative
                                        }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Ativos
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.active
                                        }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Inativos
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.inactive
                                        }}</span>
                                </div>

                                <div class="dash-card-statistics-item">
                                    <span class="dash-card-statistics-title">
                                        Todos os Cadastros
                                    </span>
                                    <app-spacer [bottom]="4"></app-spacer>
                                    <span class="dash-card-statistics-value">{{
                                        statistics.total
                                        }}</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Tabs -->
                    <div class="col-12">
                        <div class="dashboard-tabs-container">
                            <div class="dashboard-tabs">
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'all'"
                                    (click)="onTabChange('all')">
                                    Todos
                                </button>
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'cedente'"
                                    (click)="onTabChange('cedente')">
                                    Cedentes
                                </button>
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'cotista'"
                                    (click)="onTabChange('cotista')">
                                    Cotistas
                                </button>
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'prestador'"
                                    (click)="onTabChange('prestador')">
                                    Prestadores de serviço
                                </button>
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'representative'"
                                    (click)="onTabChange('representative')">
                                    Representantes
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Botões de filtro com skeleton -->
                    <div class="col-12">
                        <div class="dash-card-header"
                            style="flex-direction: column; padding-top: 0;">
                            <div class="row no-gutters">
                                <div class="col-12 d-flex justify-content-between align-items-center px-0"
                                    style="margin-top: 1.75rem;">
                                    <div class="d-flex align-items-center">
                                        <app-button [inverted]="true"
                                            class="mr-2"
                                            (onClick)="refreshData()"
                                            [disabled]="loading || loadingSummary">
                                            <svg-icon
                                                src="assets/images/icon-renew.svg"
                                                class="mr-2"></svg-icon>
                                            Atualizar
                                        </app-button>

                                        <div class="sort-button-wrapper mr-2">
                                            <span class="sort-label">Por data de
                                                criação</span>
                                            <button type="button"
                                                class="sort-button"
                                                (click)="toggleSortButton()"
                                                [disabled]="loading || loadingSummary">
                                                <svg-icon
                                                    src="assets/images/icon-arrow-up.svg"
                                                    *ngIf="sortButtonExpanded"></svg-icon>
                                                <svg-icon
                                                    src="assets/images/icon-arrow-down.svg"
                                                    *ngIf="!sortButtonExpanded"></svg-icon>
                                                <span>{{ getSortButtonLabel()
                                                    }}</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <ng-container
                                            *ngIf="permissionObj.canFilter">
                                            <app-button-with-dropdown
                                                label="Baixar tabela"
                                                iconSrc="assets/images/icon_download.svg"
                                                [showOptions]="showExportOptions"
                                                (toggleShowOptions)="toggleExportOptions()"
                                                (onClick)="toggleExportOptions()"
                                                [outline]="true"
                                                class="export-button mr-3"
                                                [disabled]="loading || loadingSummary || !users?.length">
                                                <button class="dropdown-item"
                                                    (click)="downloadTable('csv')">Baixar
                                                    como
                                                    CSV</button>
                                                <button class="dropdown-item"
                                                    (click)="downloadTable('pdf')">Baixar
                                                    como
                                                    PDF</button>
                                                <button class="dropdown-item"
                                                    (click)="downloadTable('xlsx')">Baixar
                                                    como
                                                    XLSX</button>
                                            </app-button-with-dropdown>

                                            <app-button
                                                *ngIf="hasFilters && !loading && !loadingSummary"
                                                [danger]="true" [outline]="true"
                                                (onClick)="resetForm()"
                                                class="add-button mr-2">
                                                <svg-icon
                                                    src="assets/images/icon-times.svg"
                                                    class="filter-clear-icon"></svg-icon>
                                                Limpar filtros
                                            </app-button>

                                            <app-button [inverted]="true"
                                                class="add-button"
                                                (onClick)="toggleFilterModal()"
                                                [disabled]="loading || loadingSummary">
                                                <svg-icon
                                                    src="assets/images/icon_filter.svg"
                                                    class="mr-2">
                                                </svg-icon>
                                                {{ hasFilters ? 'Editar
                                                filtros' :
                                                'Filtrar listagem' }}
                                            </app-button>
                                        </ng-container>
                                    </div>
                                </div>

                                <!-- Tags de filtros aplicados -->
                                <div class="col-12 mt-3 px-0"
                                    *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                                    <div
                                        class="d-flex flex-wrap align-items-center justify-content-end">
                                        <app-filter-tag
                                            *ngFor="let filter of appliedFilters"
                                            [label]="filter.label"
                                            [value]="filter.value">
                                        </app-filter-tag>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <app-spacer [bottom]="16"></app-spacer>
                    </div>

                    <div class="col-12 padding-container dash-card-body">
                        <div clsas="styled-scroll">
                            <table
                                *ngIf="loading || loadingSummary || paperStatusSubmitting || registerStatusSubmitting"
                                class="skeleton-table">
                                <tbody>
                                    <tr *ngFor="let number of [0,1,2]">
                                        <!-- Nome / Razão Social -->
                                        <td>
                                            <div class="dash-card-item">
                                                <div
                                                    class="dash-card-item-initials">
                                                    <ngx-skeleton-loader
                                                        appearance="circle"
                                                        [theme]="{
                                                            height: '48px',
                                                            width: '48px',
                                                            marginBottom: '0'
                                                        }">
                                                    </ngx-skeleton-loader>
                                                </div>
                                                <app-spacer
                                                    [right]="16"></app-spacer>
                                                <div
                                                    class="dash-card-item-content">
                                                    <div
                                                        class="dash-card-item-content-title">
                                                        <ngx-skeleton-loader
                                                            [theme]="{
                                                            height: '21px',
                                                            width: '180px',
                                                            marginBottom: '0'
                                                        }">
                                                        </ngx-skeleton-loader>
                                                    </div>
                                                    <div
                                                        class="dash-card-item-content-subtitle">
                                                        <ngx-skeleton-loader
                                                            [theme]="{
                                                            height: '18px',
                                                            width: '140px',
                                                            marginBottom: '0'
                                                        }">
                                                        </ngx-skeleton-loader>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Papel -->
                                        <td>
                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    <ngx-skeleton-loader
                                                        [theme]="{
                                                        height: '21px',
                                                        width: '100px',
                                                        marginBottom: '0'
                                                    }">
                                                    </ngx-skeleton-loader>
                                                </div>
                                                <div
                                                    class="dash-card-item-content-subtitle">
                                                    <ngx-skeleton-loader
                                                        [theme]="{
                                                        height: '18px',
                                                        width: '120px',
                                                        marginBottom: '0'
                                                    }">
                                                    </ngx-skeleton-loader>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Versão -->
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                                height: '28px',
                                                width: '90px',
                                                borderRadius: '20px',
                                                marginBottom: '0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </td>

                                        <!-- Criado em -->
                                        <td>
                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    <ngx-skeleton-loader
                                                        [theme]="{
                                                        height: '21px',
                                                        width: '100px',
                                                        marginBottom: '0'
                                                    }">
                                                    </ngx-skeleton-loader>
                                                </div>
                                                <div
                                                    class="dash-card-item-content-subtitle">
                                                    <ngx-skeleton-loader
                                                        [theme]="{
                                                        height: '18px',
                                                        width: '80px',
                                                        marginBottom: '0'
                                                    }">
                                                    </ngx-skeleton-loader>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Estado -->
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                                height: '28px',
                                                width: '80px',
                                                borderRadius: '20px',
                                                marginBottom: '0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </td>

                                        <!-- Ação -->
                                        <td style="text-align: right;">
                                            <div
                                                class="d-flex justify-content-end align-items-center">
                                                <div class="mr-3">
                                                    <ngx-skeleton-loader
                                                        [theme]="{
                                                        height: '20px',
                                                        width: '20px',
                                                        borderRadius: '4px',
                                                        marginBottom: '0'
                                                    }">
                                                    </ngx-skeleton-loader>
                                                </div>
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '20px',
                                                    width: '20px',
                                                    borderRadius: '4px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <app-spacer [bottom]="28"></app-spacer>
                            </table>

                            <table
                                *ngIf="!loading && !loadingSummary && !paperStatusSubmitting && !registerStatusSubmitting && users.length > 0">
                                <thead>
                                    <tr>
                                        <th>Nome / Razão Social</th>
                                        <th>Papel</th>
                                        <th>Versão</th>
                                        <th class="text-left">Criado em</th>
                                        <th class="text-left">Estado</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <ng-container
                                        *ngFor="let item of users; trackBy: trackByUserItem">
                                        <tr>
                                            <!-- Nome / Razão Social -->
                                            <td>
                                                <div class="dash-card-item">
                                                    <button type="button"
                                                        class="button row-toggle mr-2"
                                                        (click)="toggleRow(item)"
                                                        [attr.aria-expanded]="isRowExpanded(item)"
                                                        [attr.title]="isRowExpanded(item) ? 'Fechar' : 'Abrir'">
                                                        <svg-icon
                                                            src="assets/images/icon-up.svg"
                                                            fill="var(--black)"
                                                            *ngIf="isRowExpanded(item)"></svg-icon>
                                                        <svg-icon
                                                            src="assets/images/icon-down.svg"
                                                            fill="var(--black)"
                                                            *ngIf="!isRowExpanded(item)"></svg-icon>
                                                    </button>
                                                    <div
                                                        class="dash-card-item-initials">
                                                        <span>{{getInitials(item)}}</span>
                                                    </div>
                                                    <app-spacer
                                                        [right]="16"></app-spacer>
                                                    <div
                                                        class="dash-card-item-content">
                                                        <div
                                                            class="dash-card-item-content-title d-flex align-items-center">
                                                            <span>{{getDisplayName(item)}}</span>
                                                            <app-tooltip
                                                                *ngIf="item.register?.has_imported === true"
                                                                text="Importado"
                                                                [position]="'top'">
                                                                <svg-icon
                                                                    src="assets/images/icon-import.svg"
                                                                    class="ml-2"
                                                                    fill="var(--main)"
                                                                    style="font-size: 14px; cursor: help;"></svg-icon>
                                                            </app-tooltip>
                                                        </div>
                                                        <div
                                                            class="dash-card-item-content-subtitle">
                                                            {{getDocumentOnly(item)}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Papel -->
                                            <td [style.max-width]="'300px'">
                                                <div class="dash-card-item-content"
                                                    *ngIf="getRolesForBadges(item).length">
                                                    <div
                                                        class="role-badges-wrap">
                                                        <span
                                                            *ngFor="let role of getRolesForBadges(item)"
                                                            class="role-badge">
                                                            {{
                                                            role.applicable_display
                                                            || '—'
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <span
                                                    *ngIf="!getRolesForBadges(item).length">—</span>
                                            </td>

                                            <!-- Versão -->
                                            <td>
                                                <span
                                                    [ngClass]="['version-badge', getVersionBadgeClass(item)]">
                                                    {{getVersionLabel(item)}}
                                                </span>
                                            </td>

                                            <!-- Criado em -->
                                            <td class="text-left">
                                                <div
                                                    class="dash-card-item-content">
                                                    <div
                                                        class="dash-card-item-content-title">
                                                        {{getCreatedDate(item)}}
                                                    </div>
                                                    <div
                                                        class="dash-card-item-content-subtitle">
                                                        {{getCreatedTime(item)}}
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Estado -->
                                            <td class="text-left">
                                                <span
                                                    [class]="getEstadoBadgeClass(item)">
                                                    {{getEstadoAtivoInativo(item)}}
                                                </span>
                                            </td>

                                            <!-- Ação -->
                                            <td style="text-align: right">
                                                <div
                                                    class="d-flex justify-content-end align-items-center">
                                                    <app-tooltip
                                                        *ngIf="!isRegisterEmAnalise(item)"
                                                        [text]="getRegisterActionTooltip(item)"
                                                        [position]="'top'">
                                                        <button type="button"
                                                            class="button mr-2"
                                                            (click)="onRegisterActionClick($event, item)">
                                                            <svg-icon
                                                                src="assets/images/icon-ban.svg"
                                                                *ngIf="isRegisterActive(item)"></svg-icon>
                                                            <svg-icon
                                                                src="assets/images/icon-check.svg"
                                                                *ngIf="!isRegisterActive(item)"></svg-icon>
                                                        </button>
                                                    </app-tooltip>
                                                    <app-tooltip
                                                        text="Visualizar"
                                                        [position]="'top'">
                                                        <a
                                                            [routerLink]="renderLink(item)">
                                                            <svg-icon
                                                                src="assets/images/icon-eye.svg"></svg-icon>
                                                        </a>
                                                    </app-tooltip>

                                                    <div class="mr-3">
                                                        <ng-container
                                                            *ngIf="item.editing && item.register && hasPermission('change',item.register.role.applicable)">
                                                            <app-tooltip
                                                                text="Editar"
                                                                [position]="'top'">
                                                                <button
                                                                    class="button"
                                                                    (click)="redirectToEdit(item)">
                                                                    <svg-icon
                                                                        src="assets/images/icon-edit.svg"></svg-icon>
                                                                </button>
                                                            </app-tooltip>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <!-- Linha expandida: tabela interna de role_controls -->
                                        <tr *ngIf="isRowExpanded(item)"
                                            class="details-row">
                                            <td [attr.colspan]="6">
                                                <table class="details-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Papel</th>
                                                            <th>Status</th>
                                                            <th>Perfil</th>
                                                            <th>Criado em</th>
                                                            <th>Validade</th>
                                                            <th>Estado</th>
                                                            <th>Inativado</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let rc of getRoleControlsList(item); trackBy: trackByRoleControl">
                                                            <td>
                                                                <span
                                                                    class="role-badge">
                                                                    {{getRoleControlPapelName(rc)}}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    [class]="getRoleControlStatusClass(rc)"
                                                                    class="status-badge">
                                                                    {{getRoleControlStatusDisplay(rc)}}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    class="role-badge profile-badge"
                                                                    [ngStyle]="getRoleControlProfileBadgeStyle(rc)">
                                                                    {{getRoleControlProfile(rc)}}
                                                                </span>
                                                            </td>
                                                            <td>{{getRoleControlCreatedAt(rc)}}
                                                            </td>
                                                            <td>{{getRoleControlValidity(rc)}}
                                                            </td>
                                                            <td>
                                                                <span
                                                                    [class]="getRoleControlEstadoClass(rc)">
                                                                    {{getRoleControlEstado(rc)}}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    class="dash-card-item-content">
                                                                    <div
                                                                        class="dash-card-item-content-title">
                                                                        {{getRoleControlInactivationDate(rc)}}
                                                                    </div>
                                                                    <div class="dash-card-item-content-subtitle"
                                                                        *ngIf="getRoleControlInactivationTime(rc)">
                                                                        {{getRoleControlInactivationTime(rc)}}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="paper-action-cell text-end"
                                                                (click)="onPaperActionCellClick($event, item, rc)">
                                                                <ng-container
                                                                    *ngIf="!isRepresentativeRoleControl(rc) && !isRolePaperEmAnalise(rc)">
                                                                    <button
                                                                        type="button"
                                                                        class="button paper-action-btn"
                                                                        [attr.title]="getPaperActionTooltip(item, rc)">
                                                                        <svg-icon
                                                                            src="assets/images/icon-ban.svg"
                                                                            *ngIf="isRoleActive(item, rc)"></svg-icon>
                                                                        <svg-icon
                                                                            src="assets/images/icon-check.svg"
                                                                            *ngIf="!isRoleActive(item, rc)"></svg-icon>
                                                                    </button>
                                                                </ng-container>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </ng-container>

                                </tbody>
                                <app-spacer [bottom]="28"></app-spacer>
                            </table>

                            <div
                                *ngIf="users.length === 0 && !loading && !loadingSummary && !paperStatusSubmitting && !registerStatusSubmitting">
                                <app-empty-content [isVisible]="true"
                                    title="Nenhum registro encontrado"
                                    description="Não encontramos nenhum registro com os filtros aplicados."
                                    icon="/assets/images/figure_3d_search.png">
                                </app-empty-content>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dash-card-pagination" *ngIf="users.length > 0">
                <app-pagination [data]="users" [count]="count"
                    [show]="!loading && !loadingSummary && !paperStatusSubmitting && !registerStatusSubmitting"
                    [offset]="showing_to"
                    (onPageChange)="changePageData($event)"
                    [dashPagination]="true">
                </app-pagination>
            </div>
        </div>
    </div>

    <app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
        [loading]="loading" title="Filtrar listagem"
        [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
        (onApply)="filterData()" (onReset)="resetForm()">
        <div class="row">
            <div class="col-12">
                <app-input [group]="filterForm" controlName="name"
                    label="Nome / Razão Social" placeholder="Digite">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-masked-input [group]="filterForm" controlName="document"
                    label="CPF / CNPJ" documentType="cpfOrCnpj" placeholder="Digite">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12" *ngIf="activeTab === 'prestador'">
                <app-select [items]="roleOptions" [group]="filterForm"
                    controlName="agent" [multiple]="true"
                    placeholder="Selecione" label="Agente">
                </app-select>
                <app-spacer [bottom]="32"></app-spacer>
            </div>

            <div class="col-12">
                <h3>Filtrar por data de criação</h3>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-lg-6">
                <app-masked-input [group]="filterForm"
                    controlName="created_from" mask="00/00/0000" label="De"
                    placeholder="dd/mm/aaaa">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 col-lg-6">
                <app-masked-input [group]="filterForm" controlName="created_to"
                    mask="00/00/0000" label="Até" placeholder="dd/mm/aaaa">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>


            <div class="col-12">
                <div class="d-flex align-items-center">
                    <app-radio [multiple]="true" formControlName="has_imported">
                        <span style="margin-left: 8px;">Cadastros
                            Importados</span>
                    </app-radio>
                </div>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <span class="filter-section-label">Perfil de investimento de
                    cotista</span>
                <div class="filter-checkbox-group">
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="profileConservador">
                        <span>Conservador</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="profileModerado">
                        <span>Moderado</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="profileAgressivo">
                        <span>Agressivo</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="profileNaoDeclarado">
                        <span>Não declarado</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox" formControlName="profileIsento">
                        <span>Isento</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="profileNaoAplicavel">
                        <span>Não aplicável</span>
                    </label>
                </div>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <span class="filter-section-label">Status dos papéis</span>
                <div class="filter-checkbox-group">
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="statusEmAprovacao">
                        <span>Em aprovação</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="statusHomologado">
                        <span>Homologado</span>
                    </label>
                </div>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <span class="filter-section-label">Estado do cadastro</span>
                <div class="filter-checkbox-group">
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="estadoCadastroTodos"
                            (change)="onEstadoCadastroChange('todos')">
                        <span>Todos</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="estadoCadastroAtivo"
                            (change)="onEstadoCadastroChange('ativo')">
                        <span>Ativo</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox"
                            formControlName="estadoCadastroInativo"
                            (change)="onEstadoCadastroChange('inativo')">
                        <span>Inativo</span>
                    </label>
                </div>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <span class="filter-section-label">Estado dos papéis</span>
                <div class="filter-checkbox-group">
                    <label class="filter-checkbox-item">
                        <input type="checkbox" formControlName="estadoTodos"
                            (change)="onEstadoPapeisChange('todos')">
                        <span>Todos</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox" formControlName="estadoAtivo"
                            (change)="onEstadoPapeisChange('ativo')">
                        <span>Ativo</span>
                    </label>
                    <label class="filter-checkbox-item">
                        <input type="checkbox" formControlName="estadoInativo"
                            (change)="onEstadoPapeisChange('inativo')">
                        <span>Inativo</span>
                    </label>
                </div>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>
    </app-side-filter-modal>
</div>

<app-side-modal [active]="newUserModal" title="Novo cadastro"
    (onClose)="toggleNewUserModal()">
    <form [formGroup]="newUserForm">
        <div class="row">
            <!-- Campo de documento - primeiro campo -->
            <div class="col-12">
                <p *ngIf="!documentVerified && !checkingDocument"
                    class="dm-intro-text">
                    Comece inserindo o CPF ou CNPJ. Assim, a plataforma
                    verifica
                    se já existe um registro ou se será criado um novo.
                </p>
                <p *ngIf="documentVerified && !isCollaborator && !hasPendingApproval && !hasInviteSent && !hasRoleDraft && !documentExists && approvedRoles.length === 0"
                    class="dm-intro-text">
                    Este {{ getDocumentType() }} não possui cadastro.
                    Informe os
                    dados necessários para prosseguir com o cadastro.
                </p>
                <p *ngIf="documentVerified && !isCollaborator && !hasPendingApproval && !hasInviteSent && !hasRoleDraft && approvedRoles.length > 0"
                    class="dm-intro-text">
                    Cadastro identificado como <strong>{{
                        getApprovedRolesText()
                        }}</strong>.
                    Complete
                    as informações para prosseguir com o cadastro.
                </p>
                <app-masked-input [group]="newUserForm" controlName="document"
                    label="CPF / CNPJ" documentType="cpfOrCnpj"
                    [readOnly]="checkingDocument"
                    placeholder="Digite o CPF ou CNPJ">
                </app-masked-input>
                <div *ngIf="documentInviteError" class="error-message"
                    class="dm-error-message">
                    {{ documentInviteError }}
                </div>

                <!-- Loading durante verificação do documento -->
                <div class="col-12 text-center" *ngIf="checkingDocument">
                    <p class="dm-checking-text">
                        <svg-icon
                            src="assets/images/icon-loading.svg"></svg-icon>
                        Verificando
                        documento...
                    </p>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando é colaborador -->
                <div class="col-12 mt-2 dm-section"
                    *ngIf="documentExists && !checkingDocument && isCollaborator && collaboratorInfo">
                    <!-- Alerta principal - destaque -->
                    <div
                        class="dm-alert-warning">
                        <div
                            class="dm-alert-row">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"></svg-icon>
                            <div>
                                <p
                                    class="dm-alert-warning__title">
                                    Cadastro não permitido
                                </p>
                                <p
                                    class="dm-alert-warning__message">
                                    Esta pessoa já está cadastrada como
                                    <strong>colaborador</strong> e não pode
                                    ser
                                    cadastrada como cedente, cotista ou
                                    outro
                                    papel.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Card com informações do colaborador - compacto -->
                    <div
                        class="dm-summary-card">
                        <div
                            class="dm-summary-card__header">
                            <svg-icon src="assets/images/icon-user.svg"
                                class="dm-summary-card__icon"></svg-icon>
                            <p
                                class="dm-summary-card__title">
                                {{ collaboratorInfo.name }} • {{
                                getCollaboratorDocument() }}
                            </p>
                        </div>

                        <!-- Se for Master ou Owner, mostra apenas Tipo de acesso e Empresa -->
                        <div *ngIf="collaboratorInfo.collaborator_type === 'master' || collaboratorInfo.collaborator_type === 'owner'"
                            class="dm-summary-card__grid">
                            <div>
                                <p
                                    class="dm-summary-card__label">
                                    Tipo de acesso</p>
                                <p class="dm-summary-card__value">
                                    {{
                                    getCollaboratorType() }}</p>
                            </div>

                            <div>
                                <p
                                    class="dm-summary-card__label">
                                    Empresa</p>
                                <p class="dm-summary-card__value">
                                    {{ UIDefaultTheme.brand.company_name }}
                                </p>
                            </div>
                        </div>

                        <!-- Se não for Master ou Owner, mostra Tipo de acesso e Empresa (sem Perfil) -->
                        <div *ngIf="collaboratorInfo.collaborator_type !== 'master' && collaboratorInfo.collaborator_type !== 'owner'"
                            class="dm-summary-card__grid">
                            <div>
                                <p
                                    class="dm-summary-card__label">
                                    Tipo de acesso</p>
                                <p class="dm-summary-card__value">
                                    {{
                                    getCollaboratorType() }}</p>
                            </div>

                            <div>
                                <p
                                    class="dm-summary-card__label">
                                    Empresa</p>
                                <p class="dm-summary-card__value">
                                    {{ UIDefaultTheme.brand.company_name }}
                                </p>
                            </div>

                            <div
                                *ngIf="collaboratorInfo.departments && collaboratorInfo.departments.length > 0">
                                <p
                                    class="dm-summary-card__label">
                                    Departamento</p>
                                <p class="dm-summary-card__value">
                                    {{
                                    getCollaboratorDepartments() }}</p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando há aprovação pendente -->
                <div class="col-12 mt-2 dm-section"
                    *ngIf="documentExists && !checkingDocument && hasPendingApproval && pendingApprovalRole && !hasInviteSent">
                    <!-- Alerta principal - destaque -->
                    <div
                        class="dm-alert-warning">
                        <div
                            class="dm-alert-row">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"></svg-icon>
                            <div>
                                <p
                                    class="dm-alert-warning__title">
                                    Cadastro já existe
                                </p>
                                <p
                                    class="dm-alert-warning__message">
                                    Não é possível adicionar um novo papel
                                    pois
                                    o cadastro como <strong>{{
                                        pendingApprovalRole }}</strong>
                                    ainda
                                    não foi aprovado.
                                </p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando há convite já enviado (used ou viewed) -->
                <div class="col-12 mt-2 dm-section"
                    *ngIf="documentExists && !checkingDocument && hasInviteSent && inviteStatus">
                    <!-- Alerta principal - destaque -->
                    <div
                        class="dm-alert-warning">
                        <div
                            class="dm-alert-row">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"></svg-icon>
                            <div>
                                <p
                                    class="dm-alert-warning__title">
                                    Convite já enviado
                                </p>
                                <p
                                    class="dm-alert-warning__message">
                                    Um convite já foi enviado ao
                                    usuário<span
                                        *ngIf="invitedData?.sender_name">
                                        por
                                        <strong>{{
                                            invitedData.sender_name
                                            }}</strong></span>. Não
                                    é
                                    possível cadastrá-lo novamente enquanto
                                    ele
                                    não concluir o cadastro.
                                </p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando há role_draft (adição de papel em andamento) -->
                <div class="col-12 mt-2 dm-section"
                    *ngIf="!checkingDocument && hasRoleDraft && roleDraftInfo">
                    <!-- Alerta principal - destaque -->
                    <div
                        class="dm-alert-warning">
                        <div
                            class="dm-alert-row">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"></svg-icon>
                            <div>
                                <p
                                    class="dm-alert-warning__title">
                                    Adição de papel em andamento
                                </p>
                                <p
                                    class="dm-alert-warning__message">
                                    Não é possível adicionar um novo papel
                                    pois
                                    a adição do papel <strong>{{
                                        roleDraftInfo.applicable_display ||
                                        roleDraftInfo.name }}</strong> está
                                    em andamento.
                                </p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Informação se o documento já existe (não é colaborador, sem aprovação pendente, sem convite enviado, sem role_draft e sem papéis aprovados) -->
                <div class="col-12 mt-2 dm-section"
                    *ngIf="documentExists && !checkingDocument && !isCollaborator && !hasPendingApproval && !hasInviteSent && !hasRoleDraft && !approvedRoles.length && userName">
                    <!-- Alerta informativo - cadastro já existe -->
                    <div
                        class="dm-alert-info">
                        <div
                            class="dm-alert-row">
                            <svg-icon src="assets/images/icon-info.svg"
                                fill="var(--info)"
                                class="dm-alert-info__icon"></svg-icon>
                            <div>
                                <p
                                    class="dm-alert-info__title">
                                    Cadastro já realizado
                                </p>
                                <p
                                    class="dm-alert-info__message">
                                    {{ getRolesMessage() }}
                                    <ng-container
                                        *ngIf="getRolesArray().length > 0">
                                        <ng-container
                                            *ngFor="let role of getRolesArray(); let last = last">
                                            <strong>{{ role
                                                }}</strong><ng-container
                                                *ngIf="!last"> -
                                            </ng-container>
                                        </ng-container>.
                                    </ng-container>
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Card com informações do usuário - compacto -->
                    <div
                        class="dm-summary-card">
                        <div
                            class="dm-summary-card__header">
                            <svg-icon src="assets/images/icon-user-check.svg"
                                class="dm-summary-card__icon"></svg-icon>
                            <p
                                class="dm-summary-card__title">
                                {{ userName }} • {{
                                newUserForm.controls.document.value }}
                            </p>
                        </div>

                        <div class="dm-summary-card__grid"
                            *ngIf="currentPapers.length > 0">
                            <div>
                                <p
                                    class="dm-summary-card__label">
                                    Papel atual</p>
                                <p
                                    class="dm-summary-card__value--multiline">
                                    {{ getCurrentPapersText() }}</p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>
            </div>


            <!-- Campos - só aparecem após verificação do documento sem erro, sem role_draft e quando há papéis disponíveis -->
            <ng-container
                *ngIf="(documentVerified || showOtherFields) && !hasRoleDraft && !isCollaborator && !hasPendingApproval && !hasInviteSent">
                <!-- Nome primeiro -->
                <div class="col-12 mt-2">
                    <app-input [group]="newUserForm" controlName="full_name"
                        [label]="isCnpjDocument ? 'Razão Social' : 'Nome completo'"
                        placeholder="Digite" [maxLength]="60">
                    </app-input>
                    <!-- Badges dos papéis aprovados -->
                    <div *ngIf="documentVerified && !documentInviteError && approvedRoles.length > 0"
                        class="dm-role-badges">
                        <span *ngFor="let role of approvedRoles"
                            class="dm-role-badge">
                            {{ role.applicable_display }}
                        </span>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Email -->
                <div class="col-12">
                    <app-input type="email" label="Email" [group]="newUserForm"
                        controlName="email">
                    </app-input>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Seleção do Papel -->
                <div class="col-12">
                    <app-select label="Selecione o papel" [group]="newUserForm"
                        controlName="role" [items]="primaryRoleOptions"
                        placeholder="Selecione">
                    </app-select>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Agente (só aparece se for provider) -->
                <div class="col-12"
                    *ngIf="selectedNewUserApplicable === 'provider'">
                    <app-select label="Agente" [group]="newUserForm"
                        controlName="agent" [items]="roleOptions"
                        [multiple]="true" placeholder="Selecione">
                    </app-select>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Fundo de interesse -->
                <div class="col-12">
                    <app-select label="Fundo de interesse" [group]="newUserForm"
                        controlName="interest_fund" [items]="fundOptions"
                        [placeholder]="loadingFunds ? 'Carregando fundos...' : 'Selecione'">
                    </app-select>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>
        </div>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="toggleNewUserModal()" [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6 d-flex justify-content-end">
                <!-- Botão Verificar - aparece antes da verificação do documento -->
                <app-button *ngIf="!documentVerified && !hasRoleDraft"
                    (onClick)="verifyDocument()" class="add-button"
                    [disabled]="!newUserForm.controls.document.value || checkingDocument || newUserForm.controls.document.invalid"
                    [loading]="checkingDocument">
                    Verificar
                </app-button>

                <!-- Botão Cadastrar - aparece após verificação ou quando está editando (mas não quando há role_draft) -->
                <app-button
                    *ngIf="(documentVerified || showOtherFields) && !hasRoleDraft"
                    (onClick)="registerNewUser()" class="add-button"
                    [disabled]="newUserForm.invalid || checkingDocument || isCollaborator || hasPendingApproval || hasInviteSent"
                    [loading]="sendingRequest">
                    Cadastrar
                </app-button>
            </div>
        </div>
    </form>
</app-side-modal>

<app-carbon-warning-modal [active]="showRegisterStatusModal"
    [title]="getRegisterActionTitle(selectedRegisterItem)"
    [customContent]="true" [contentOverflowVisible]="true"
    [confirmText]="selectedRegisterItem && isRegisterActive(selectedRegisterItem) ? 'Confirmar inativação' : 'Confirmar ativação'"
    [cancelText]="'Cancelar'" [loading]="registerStatusSubmitting"
    [disableConfirm]="registerStatusConfirmDisabled"
    [confirmAction]="confirmRegisterStatusChange.bind(this)"
    [cancelAction]="closeRegisterStatusModal.bind(this)"
    (onClose)="closeRegisterStatusModal()">
    <div class="paper-status-modal register-status-modal">
        <ng-container
            *ngIf="selectedRegisterItem && isRegisterActive(selectedRegisterItem)">
            <p>
                {{getRegisterActionMessage(selectedRegisterItem)}}
                <strong> {{selectedRegisterItem ?
                    getDisplayName(selectedRegisterItem) : '-'}}</strong>?
            </p>
            <app-spacer [top]="8"></app-spacer>
            <app-input [group]="registerStatusReasonForm" controlName="reason"
                label="Motivo" [rows]="4" placeholder="Descreva o motivo">
            </app-input>
        </ng-container>

        <ng-container
            *ngIf="selectedRegisterItem && !isRegisterActive(selectedRegisterItem)">
            <ng-container *ngIf="isRegisterActivationSinglePaper()">
                <p>
                    O cadastro está inativo. Ao confirmar, o papel <strong>{{
                        getSingleRegisterActivationPaperLabel() }}</strong> será
                    ativo juntamente com o cadastro do usuário
                    <strong>{{ getDisplayName(selectedRegisterItem) }}</strong>.
                    Deseja continuar?
                </p>
            </ng-container>

            <ng-container *ngIf="isRegisterActivationMultiPaper()">
                <p class="register-activate-intro">
                    Para ativar o cadastro, selecione o papel que deseja
                    reativar.
                </p>
                <div class="register-activate-select-wrap">
                    <app-select [items]="registerActivatePaperSelectItems"
                        [group]="registerActivatePapersForm"
                        controlName="paperId" placeholder="Selecione o papel"
                        label="Papel"></app-select>
                </div>
            </ng-container>
            <app-spacer [top]="8"></app-spacer>
            <app-input [group]="registerStatusReasonForm" controlName="reason"
                label="Motivo" [rows]="4" placeholder="Descreva o motivo">
            </app-input>
        </ng-container>
    </div>
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showPaperStatusModal"
    [title]="getPaperActionTitle(selectedPaperItem, selectedPaperRole)"
    [customContent]="true"
    [confirmText]="selectedPaperItem && selectedPaperRole && isRoleActive(selectedPaperItem, selectedPaperRole) ? 'Confirmar inativação' : 'Confirmar ativação'"
    [cancelText]="'Cancelar'" [loading]="paperStatusSubmitting"
    [disableConfirm]="!paperStatusReasonForm.valid"
    [confirmAction]="confirmPaperStatusChange.bind(this)"
    [cancelAction]="closePaperStatusModal.bind(this)"
    (onClose)="closePaperStatusModal()">
    <div class="paper-status-modal">
        <p>
            {{getPaperActionMessage(selectedPaperItem, selectedPaperRole)}}
            <strong>{{selectedPaperRole ?
                getRoleLabelForModal(selectedPaperRole) : ''}}</strong> do
            cadastro:
        </p>
        <p class="paper-status-modal-name">
            <strong>{{selectedPaperItem ? getDisplayName(selectedPaperItem) :
                '-'}}</strong>
        </p>
        <app-spacer [top]="8"></app-spacer>
        <app-input [group]="paperStatusReasonForm" controlName="reason"
            label="Motivo" [rows]="4" placeholder="Descreva o motivo">
        </app-input>
    </div>
</app-carbon-warning-modal>